export const DIST_PRODUCT = Object.freeze({
  meinbuero: 'meinbuero',
  orgamax: 'orgamax',
})
